import {Component, Injector, OnInit} from '@angular/core';
import { GeozoneViewModel } from "../Model/GeozoneViewModel";
import { ZoneService } from "../../../../services/zones.service";
import {DialogBaseComponent} from "../../base-admin-panel/dialog-base/dialog-base.component";

@Component({
    selector: 'app-create-geozone-dialog',
    templateUrl: './create-geozone-dialog.component.html',
    styleUrls: ['./create-geozone-dialog.component.css'],
    standalone: false
})
export class CreateGeozoneDialogComponent extends DialogBaseComponent<GeozoneViewModel> {

  private zonesService: ZoneService;

  constructor(protected injector: Injector) {
    super(injector);
    this.zonesService = injector.get(ZoneService);
  }

  submit()
  {
    this.zonesService.CreateZone(this.model)
      .subscribe((res) =>
      {
        this.syncService.NotifyEntityChanged("Geozone", this.model.Id);
        super.submit();
      });
    }
}
